import React from 'react'
import {
  Grid, Card, Image, Button,
} from 'semantic-ui-react'
import { Link } from "react-router-dom"

const OptionalButtons = ({ id, product }) => {
  let output
  switch(product) {
    case 'email':
      return (
        <>
          <Link to={`/message/email/${id}/coedit`}>
            <Button
              primary
              className="buttonTwo"
            >
              Start Co-editing
            </Button>
          </Link>
          <Link to={`message/page/${id}/convert`}>
            <Button
              primary
              className="buttonThree"
            >
              Convert to Page
            </Button>
          </Link>
        </>
      )
    case 'page':
      return null
    case 'popup':
      return null
    default:
      return null
  }
}

export default OptionalButtons
